import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { updateBlogTag, getBlogTagById } from "adminApi/BlogApi/BlogTag";
import { BlogTagRules } from "validation/ValidationRules";
import { validateForm } from "utils/validation";
import Spinner from "Common/Globle/Spinner";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import fields from "../../json/BlogTagFields.json";
import BlogTagForm from "../AddBlogTag/Components/BlogTagForm";

const EditBlogTag = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { formdata } = fields;

    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setValues, setErrors } = useFormChange(initialValues, BlogTagRules);

    const { loading: loadingFetch } = useFetchFormDataById(id, formdata, getBlogTagById, setValues);

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => await updateBlogTag({ id, data: formValues }),
        (vals) => {
            const err = validateForm(vals, BlogTagRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Tag updated successfully"
    );

    return (
        <>
            {(loadingFetch || loadingSubmit) && <Spinner isSpinner={true} />}
            <BlogTagForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Edit Blog Tag"
                submitLabel="Update Tag"
            />
        </>
    );
};

export default EditBlogTag;
